<template>
    <div class="row" :data-expand="isExpand ? true : null">
        <div class="cells" v-on:click="toggleExpand()">
            <span class="cell" data-size="status" data-align="center">
                <span class="icon-status"
                      :data-icon="histItem.cmplStat === 'E' ? 'error' : histItem.userNm == 'System' ? 'system' : 'user'"
                      :title="histItem.userNm == 'System' ? 'System' : 'User'">System</span>
            </span>
            <span class="cell" data-size="date">
                <time datetime="">{{convertUtcTimezoneToLocal(histItem.timeLine)}}</time>
            </span>
            <span class="cell" data-size="type">
                {{ $t('AUDIT.FILTER.EVAL_POLICY')}}<!--검사한 정책-->
            </span>
            <span class="cell" data-size="user">
                {{histItem.userNm}}
            </span>
            <span class="cell">
                {{ $t('AUDIT.LABEL.CASE.START_EVALUATION')}}&nbsp;:&nbsp;
                <button @click="goToHistory(histItem)" style="text-decoration: underline;">{{histItem.userDefiYn == constants.PARAM.SELECT.N ? histItem[$i18n.locale+'Title'] : histItem.plcyNm}}</button>
            </span>
            <span class="cell" data-align="center">
                <button type="button" class="buttons-icon" data-type="ghost" data-icon="expand"
                        :data-expand="isExpand ? true : null">collapse / expand</button>
            </span>
        </div>

        <div class="expand-container">
            <div-loading v-if="isExpand && cmplStartInfo == null"></div-loading>
            <!-- inner tables -->
            <table class="tbl-inner" v-if="cmplStartInfo !== null">
                <caption>{{ $t('AUDIT.FILTER.CHANGE_ASSESSMENT_ITEM')}}</caption>
                <colgroup>
                    <col style="width: 185px;">
                </colgroup>
                <thead>
                <tr>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.ITEM')}}<!--항목--></th>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.DETAIL_CONTENTS')}}<!--상세 내용--></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th>{{ $t('AUDIT.COMPLIANCE.NAME')}}<!--이름--></th>
                    <td>{{histItem.userDefiYn == constants.PARAM.SELECT.N ? histItem[$i18n.locale+'Title'] : histItem.plcyNm}}</td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.COMPLIANCE.POLICY_REVISION')}}<!--수정 정책--></th>
                    <td>{{histItem.plcyRvsn}}</td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.COMPLIANCE.EVAL_SCOPE')}}<!--검사 범위--></th>
                    <td>
                        <span v-for="(acc, idx) of cmplStartInfo.accList" class="item" :key="idx">{{acc}}</span>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.COMPLIANCE.EVAL_REGION')}}</th>
                    <td>
                        <span v-for="(region, idx) of cmplStartInfo.regionList" class="item" :key="idx">{{region}}</span>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.COMPLIANCE.EVAL_START_TIME')}}<!--검사 시작 시간--></th>
                    <td>
                        <span class="item"><time
                            datetime="">{{convertUtcTimezoneToLocal(cmplStartInfo.timeLine)}}</time></span>
                        <!--                        <span class="item">자동검사(현재 정보 없음. 추가 필요)</span>-->
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.COMPLIANCE.EVAL_END_TIME')}}<!--검사 종료 시간--></th>
                    <td>
                        <time datetime="">
                            {{convertUtcTimezoneToLocal(cmplFinishInfo.stTime!=null?cmplFinishInfo.stTime:cmplFinishInfo.timeLine)}}
                        </time>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.COMPLIANCE.APPLIED_RULES')}}<!--적용된 규칙--></th>
                    <td class="size-fit">

                        <table class="tbl-inner-details">
                            <caption>적용된 규칙</caption>
                            <thead>
                            <tr>
                                <th scope="col">{{ $t('AUDIT.COMPLIANCE.HEADER.NAME')}}<!--이름--></th>
                                <th scope="col">{{ $t('AUDIT.COMPLIANCE.HEADER.EVAL_STATUS')}}<!--검사 상태--></th>
                                <th scope="col">{{ $t('AUDIT.COMPLIANCE.HEADER.REVISION')}}<!--수정 버전--></th>
                                <th scope="col">{{ $t('AUDIT.COMPLIANCE.HEADER.EVALUATED_TIME')}}<!--검사 시작 시간--></th>
                                <th scope="col">{{ $t('AUDIT.COMPLIANCE.HEADER.NEXT_EVALUATION_TIME')}}
                                    <!--다음 검사 시간--></th>
                            </tr>
                            </thead>
                            <tbody>
                            <template v-for="(rule, idx) of arrRuleInfo">
                                <tr :key="`rt_${idx}`">
                                    <td><a href="">{{histItem.userDefiYn == constants.PARAM.SELECT.N ? rule[$i18n.locale+'RuleTitle'] : rule.ruleNm}}</a></td>
                                    <td class="txt-c">{{rule.cmplRslt == 'F' ? $t('COMPLIANCE.EVAL_STAT.FAILED') : (rule.cmplRslt == 'E' ? $t('COMPLIANCE.EVAL_STAT.ERROR') :
                                        $t('COMPLIANCE.EVAL_STAT.PASSED'))}}
                                    </td>
                                    <td class="txt-c">{{rule.ruleRvsn}}</td>
                                    <td class="txt-c">
                                        <time datetime="">{{convertUtcTimezoneToLocal(rule.stTime)}}</time>
                                    </td>
                                    <td class="txt-c">{{ $t('COMPLIANCE.EVAL_STAT.PASSED')}}</td>
                                </tr>
                                <tr v-if="!isJSON(rule.evntLog)" :key="`el_${idx}`">
                                    <td colspan="5" class="json" v-html="getRsltMsg(rule)">
                                        {{rule.evntLog}}
                                    </td>
                                </tr>
                                <tr v-else :key="`${rule.ruleId}_${rKey}`">
                                    <td colspan="5" class="json" v-html="getRsltMsgByJSON(rule)">
                                    </td>
                                </tr>
                            </template>
                            </tbody>
                        </table>

                    </td>
                </tr>
                </tbody>
            </table>

        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: 'ExpandComplianceStart',
        props: ['histItem', 'commonInfoVal'],
        data: function () {
            return {
                cmplStartInfo: null,
                cmplFinishInfo: null,
                arrRuleInfo: [],
                isExpand: false,
                ruleMsg: new Map(),
                //mulLangList: [],
                rgnLists:[],
                rKey: 1
            }
        },
        created: function() {
            this.settingCommonInfo()
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId',
            }),
            getLocale: function() {
                return this.$i18n.locale
            },
            evntLogKeyList: function() {
                return {
                    'errRuleMsg': this.$t('COMPLIANCE.LABEL.MESSAGE'),
                    'instId': this.$t('COMPLIANCE.WHITELIST.HEADER.RESOURCE_ID'),
                    'instNm': this.$t('COMPLIANCE.WHITELIST.HEADER.RESOURCE_NAME'),
                    'instType': this.$t('COMPLIANCE.WHITELIST.HEADER.RESOURCE'),
                    'os': 'OS',
                    'rgn': this.$t('COMPLIANCE.WHITELIST.HEADER.REGION'),
                    'prodNm': this.$t('COMPLIANCE.WHITELIST.HEADER.PRODUCT'),
                    'svcGrpNm': this.$t('SETTING.WHITELIST.TABLE.SERVICEGROUP'),
                    'secrGrp': this.$t('PRODUCT.security-groups'),
                }
            },
            getMulLangList: function(){
                return this.commonInfoVal.mulLangList ? this.commonInfoVal.mulLangList : [];
            }
        },
        watch: {
            getLocale: function() {
                this.rKey++
            }
        },
        methods: {
            selectComplianceInfo() {
                const url = `/api/governance/audit/expand/compliance/info`
                let ruleData = {
                    'cmpnId': this.curCmpnId,
                    'intgId': this.histItem.intgId,
                    'cmplId': this.histItem.cmplId
                }
                this.http.post(url, ruleData)
                    .then((result) => {
                        if (result.data.status === 'ok') {

                            let arrCmplInfo = result.data.result

                            let baseRulesInfo = _.filter(arrCmplInfo, {'histType': this.constants.HIST_TYPE.COMPLIANCE_EXECUTE})
                            this.cmplStartInfo = _.head(_.filter(arrCmplInfo, {'histType': this.constants.HIST_TYPE.COMPLIANCE_START}))
                            this.cmplFinishInfo = _.head(_.filter(arrCmplInfo, {'histType': this.constants.HIST_TYPE.COMPLIANCE_FINISH}))
                            for (let rule of baseRulesInfo) {
                                if (rule.evntLog !== undefined && rule.evntLog.length > 0) {
                                    let evntLogList = rule.evntLog.split(' | ');
                                    let temp = this.makeRuleMsg(evntLogList, rule)
                                    for (let t of temp) {
                                        this.ruleMsg.set(t[0], t[1])
                                    }
                                }
                            }
                            this.arrRuleInfo = baseRulesInfo;
                        } else {
                            // TODO :: Error 처리
                        }
                    }).catch(error => {
                    // TODO :: Error 처리
                });
            },
            isJSON(text) {
                return this.Common.isJSON(text);
            },
            convertUtcTimezoneToLocal: function (date) {
                return date == null ? '-' : this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale)
            },
            toggleExpand: function () {
                this.isExpand = !this.isExpand
                this.isExpand && this.cmplStartInfo == null ? this.selectComplianceInfo() : false
            },
            goToHistory: function (plcy) {
                const path = "/compliance/log";
                this.$router.push({path: path, query: {cmpl: plcy.cmplId, rslt: plcy.intgId} });
            },
            getRsltMsgByJSON: function (rule) {
                let returnVal = '';
                let returnValList = [];
                let self = this;
                for (let accId of this.cmplStartInfo.accList) {
                    let accIds = accId.split("(")[0];
                    returnValList = this.settingNewEventLog(rule, JSON.parse(rule.evntLog), accIds.trim())
                    if (returnValList.length > 0) {
                        returnVal = returnVal.concat('=================', ' <br/> ');
                        let temp = "<h3> * " + this.$t('COMPLIANCE.WHITELIST.HEADER.ACCOUNT_NAME', this.getLocale) + " : " + accId + "</h3>";
                        returnVal = returnVal.concat(temp, ' <br/> ');
                        _.forEach(returnValList, function (val) {
                            returnVal = returnVal.concat('-----------------', ' <br/> ');
                            returnVal = self.findLabel(val, returnVal)
                        });
                    }
                }

                return returnVal;
            },
            findLabel: function (val, returnVal) {
                let self = this;
                let keyList = Object.keys(val)
                _.forEach(keyList, function(key){
                    if(self.evntLogKeyList[key] !== undefined){
                        let itemVal = key==='rgn'?self.getRgnWithNewLine(val[key].split(', ')):self.isArray(val[key]);
                        let temp = "    # " + self.evntLogKeyList[key] + " : " + itemVal;
                        returnVal = returnVal.concat(temp, " <br/>")
                    }
                })
                return returnVal
            },
            getRgnWithNewLine: function(rgnLists){
                let self = this;
                let returnVal = '';
                let cnt = 1;
                _.forEach(rgnLists, function(rgn){
                    let rgnNm = rgn.trim();
                    if(self.commonInfoVal !=null && self.commonInfoVal.rgnList != null && _.findIndex(self.commonInfoVal.rgnList, {rgnId : rgn})>-1){
                        rgnNm = _.find(self.commonInfoVal.rgnList, {rgnId : rgn}).rgnNm;
                    }

                    if(rgnLists.length > cnt){
                        returnVal = returnVal.concat(rgnNm, ', ')
                    }else{
                        returnVal = returnVal.concat(rgnNm)
                    }
                    cnt++;
                });
                return returnVal;
            },
            isArray:function(val){
              let returnVal = '';
              if(typeof val === 'object' && val.length > 1){
                  let valLeng = val.length;
                  let cnt = 1;
                  for(let item of val){
                      if(cnt < valLeng){
                          returnVal = returnVal.concat(item, " <br/>")
                      }else{
                          returnVal = returnVal.concat(item)
                      }
                      cnt++
                  }
              }else{
                  returnVal = val
              }
              return returnVal
            },
            settingNewEventLog: function (rule, evntLogList, accId) {
                let tempInstList = [];
                for (let evntLog of evntLogList) {
                    if (evntLog.accId === accId) {
                        for (let cmplInfo of evntLog.cmplRsltInfo) {
                            let tempErrMsg = this.setErrRuleMsg(cmplInfo, rule)
                            for (let inst of cmplInfo.instInfoList) {
                                let omitInst = _.cloneDeep(inst);
                                omitInst = _.omit(omitInst, 'rgn')
                                if (_.find(tempInstList, inst) !== undefined) {
                                    let tempInst = _.find(tempInstList, inst);
                                    if (tempInst['errRuleMsg'] != null && tempInst['errRuleMsg'].indexOf(tempErrMsg) === -1) {
                                        this.checkIsArray(tempInst['errRuleMsg'], tempErrMsg)
                                    }
                                } else if(_.find(tempInstList, omitInst) !== undefined){
                                    let tempInst = _.find(tempInstList, omitInst);
                                    if(tempInst['errRuleMsg'] != null && tempInst['errRuleMsg'].indexOf(tempErrMsg) === -1){
                                        this.checkIsArray(tempInst['errRuleMsg'], tempErrMsg)
                                    }
                                    if(tempInst['rgn'] != null && tempInst['rgn'].indexOf(inst['rgn']) === -1){
                                        tempInst['rgn'] = tempInst['rgn'] + ", " + inst['rgn'];
                                    }
                                }else {
                                    let tempInst = _.cloneDeep(inst);
                                    tempInst['errRuleMsg'] = [tempErrMsg];
                                    tempInstList.push(tempInst);
                                }
                            }
                        }
                    }
                }
                return tempInstList;
            },
            checkIsArray:function (source, target){
                for(let item of target){
                    if(source.indexOf(item) === -1){
                        source.push(item)
                    }
                }
            },
            setErrRuleMsg: function (cmplInfo, rule) {
                let returnValList = [];
                if(cmplInfo.evntLogM != undefined && Array.isArray(cmplInfo.evntLogM)){
                    for(let cmpl of cmplInfo.evntLogM){
                        let logVal = cmpl.val;
                        if(this.Common.isJSON(logVal)){
                            logVal = JSON.parse(logVal)
                        }
                        this.findLangPack(cmpl.code, logVal, returnValList)
                    }
                }else{
                    let logVal = cmplInfo.evntLogM.val;
                    if(this.Common.isJSON(logVal)){
                        logVal = JSON.parse(logVal)
                    }
                    returnValList = this.findLangPack(cmplInfo.evntLogM.code, logVal, returnValList)
                }
                return returnValList;
            },
            getRsltMsg: function (rule) {
                let returnVal = '';
                let returnValList = [];
                if (this.cmplStartInfo.accList !== undefined) {
                    for (let acc of this.cmplStartInfo.accList) {
                        let jsonVal = this.ruleMsg.get(acc + ":" + rule.ruleRvsnId);
                        let langPack = '';
                        if (jsonVal !== undefined) {
                            for (let val of jsonVal) {
                                if (this.Common.isJSON(val)) {
                                    let jsonItem = JSON.parse(val);
                                    let keySet = Object.keys(jsonItem);
                                    for (let key of keySet) {
                                        returnValList = this.findLangPack(key, jsonItem[key], returnValList);
                                    }
                                } else {
                                    returnValList = this.findLangPack(val, null, returnValList);
                                }

                            }
                        }
                    }
                    _.forEach(returnValList, function (val) {
                        returnVal = returnVal.concat(val, ' <br/> ');
                    });
                } else {
                    //todo
                    returnVal = rule.evntLog
                }

                return returnVal;
            },
            findLangPack: function (key, valMap, returnValList) {
                let langPack = '';
                if(key.split('%$%').length > 1){
                    let keyList = key.split('%$%');
                    for(let item of keyList){
                        if(this.Common.isJSON(item)){
                            let jsonItem = JSON.parse(item);
                            let keySet = Object.keys(jsonItem);
                            for(let newKey of keySet){
                                returnValList = this.findLangPack(newKey, jsonItem[newKey], returnValList);
                            }
                        }else{
                            langPack = this.accumulateLangPack(item, valMap);
                            this.setLanguage(returnValList, langPack);
                        }
                    }
                }else{
                    langPack = this.accumulateLangPack(key, valMap);
                    this.setLanguage(returnValList, langPack);
                }
                return returnValList;
            },
            accumulateLangPack: function(key, valMap){
                let langPack = '';
                let isFind = false;
                //console.log("this.mulLangList:", this.mulLangList);
                //if(this.mulLangList) {
                    for (let code of this.getMulLangList) {
                        if (code.evntCd == key) {
                            //console.log(code.ko, this.$i18n.locale, code[this.$i18n.locale]) //TODO language pack 적용 예정
                            if (valMap != null) {
                                langPack = this.makeLangPack(code[this.$i18n.locale] != null ? code[this.$i18n.locale] : code.ko, valMap);
                            } else {
                                langPack = code.ko;
                            }
                            isFind = true;
                        }
                    }
                //}
                if(!isFind){
                    langPack = key;
                }
                return langPack;
            },
            makeLangPack: function (lang, valMap, rule) {
                let returnLang = lang
                for (let key of Object.keys(valMap)) {
                    let target = '#{' + key + '}#';
                    let source = _.includes(['thisWeek','thisMonth','thisYear','hour','day','week','month','year'], valMap[key])? this.$t('BASIC_FORMATION_UNIT.'+valMap[key], this.getLocale) :valMap[key];
                    //console.log(target, source, rule)
                    //console.log(lang.replace(target, source));
                    if (typeof source === 'object') {
                        if (rule != undefined && rule.cndVal != undefined) {
                            returnLang = returnLang.replace(target, this.findBasicForm(rule.cndVal[0].tmpltId, source));
                        } else {
                            returnLang = returnLang.replace(target, source);
                        }
                    } else {
                        returnLang = returnLang.replace(target, source);
                    }
                }
                return returnLang;
            },
            findBasicForm: function (tmpltId, source) {
                let newSource = [];
                let b = false;
                _.forEach(this.$store.state.templateList, function (item) {
                    if (tmpltId == item.tmpltId) {
                        _.forEach(source, function (id) {
                            if (item.basicFormation.cnd.svcGrp != undefined) {
                                _.forEach(item.basicFormation.cnd.svcGrp.unit, function (svc) {
                                    if (svc.key == id) {
                                        newSource.push(svc.val);
                                        b = true;
                                    }
                                })
                            }
                            if (item.basicFormation.cnd.view != undefined && item.basicFormation.cnd.view.unit != undefined) {
                                _.forEach(item.basicFormation.cnd.view.unit, function (svc) {
                                    if (svc.key == id) {
                                        //console.log(svc.key, svc.val)
                                        newSource.push(svc.val);
                                        b = true;
                                    }
                                })
                            }
                            if (!b) {
                                newSource.push(id);
                            }
                        })
                    }
                })
                return newSource;
            },
            setLanguage: function (returnValList, langPack) {
                if (!_.includes(returnValList, langPack) && langPack != '') {
                    returnValList.push(langPack);
                }
            },
            makeRuleMsg: function (evntLogList, rule) {
                const returnMsg = new Map();
                for (let acc of this.cmplStartInfo.accList) {
                    for (let envt of evntLogList) {
                        let logList = envt.split('%$%')
                        if (logList.length > 0) {
                            let accId = logList[0].trim();
                            let log = this.setLogs(logList);
                            if (acc.indexOf(accId) > -1) {
                                let key = acc + ":" + rule.ruleRvsnId
                                if (returnMsg.get(key) == null) {
                                    returnMsg.set(key, log.split('%$%'));
                                } else {
                                    for (let logItem of log.split('%$%')) {
                                        if (returnMsg.get(key).indexOf(logItem) == -1) {
                                            returnMsg.get(key).push(logItem);
                                        }
                                    }
                                }
                            }
                        } else {
                            let key = acc + ":" + rule.ruleRvsnId
                            if (returnMsg.get(key) == null) {
                                returnMsg.set(key, '');
                            }
                        }
                    }
                }
                return returnMsg;
            },
            setLogs: function (logList) {
                let logs = '';
                if (logList.length > 1) {
                    let cnt = 0;
                    for (let log of logList) {
                        if (cnt > 0) {
                            logs = logs.concat(log, '%$%');
                        }
                        cnt++;
                    }
                    //logs = logs.concat(' <br/> ');
                } else {
                    logs = logList[1] != null ? logList[1] : '';
                }
                return logs
            },
            settingCommonInfo:function(){
                this.mulLangList = this.commonInfoVal.mulLangList
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/audit/expand/complianceStart.vue